import { useEffect } from 'react'

import { useLeadContext } from 'modules/lead/context'
import { useTransmissionDataContext, useTransmissionContext } from 'modules/transmission/context'
import { getLeadVariant } from 'modules/transmission/components/leadMessage'

const useLeadVariant = () => {
  const {
    leadVariant,
    setLeadVariant,
    postLead: { response: { contactId, isInWindowTime, isParticipant } }
  } = useLeadContext()

  const {
    code,
    enableVodPlayback,
    maxParticipants,
    status,
    playbackStatus
  } = useTransmissionDataContext()

  const { isHotmartProvider } = useTransmissionContext()

  useEffect(() => {
    setLeadVariant((
      code && contactId
        && getLeadVariant({
          enableVodPlayback,
          maxParticipants,
          status,
          isHotmartProvider,
          playbackStatus,
          isInWindowTime,
          isParticipant
        })
    ) || null)
  }, [
    code,
    contactId,
    enableVodPlayback,
    maxParticipants,
    status,
    isHotmartProvider,
    playbackStatus,
    isInWindowTime,
    isParticipant,
    setLeadVariant
  ])

  return { leadVariant }
}

export default useLeadVariant
